import {
  GET_SOURCE_OF_PAYMENTS,
  SOURCE_OF_PAYMENT_ERROR,
  SHOW_SOURCE_OF_PAYMENT_LOADING,
  SHOW_EDIT_SOURCE_OF_PAYMENT_LOADING,
  GET_SOURCE_OF_PAYMENT_DETAILS,
  CREATE_SOURCE_OF_PAYMENT,
  EDIT_SOURCE_OF_PAYMENT,
  DELETE_SOURCE_OF_PAYMENT,
} from '../actions/types';

/**.
 * maco-magsael-sc-984: YMP Online - Accounting - Source of Payment Collection
 */

const initialState = {
  sourceOfPaymentList: [],
  sourceOfPaymentID: null,
  sourceOfPaymentDetails: null,
  sourceOfPaymentLoading: false,
  editSourceOfPaymentLoading: false,
  error: {},
};
// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_SOURCE_OF_PAYMENT_LOADING:
      return {
        ...state,
        sourceOfPaymentLoading: true,
      };
    case SHOW_EDIT_SOURCE_OF_PAYMENT_LOADING:
      return {
        ...state,
        editSourceOfPaymentLoading: true,
      };
    case GET_SOURCE_OF_PAYMENTS:
      return {
        ...state,
        sourceOfPaymentList: payload,
        sourceOfPaymentLoading: false,
      };
    case SOURCE_OF_PAYMENT_ERROR:
      return {
        ...state,
        error: payload,
        sourceOfPaymentLoading: false,
      };
    case GET_SOURCE_OF_PAYMENT_DETAILS:
      return {
        ...state,
        sourceOfPaymentDetails: payload,
        sourceOfPaymentLoading: false,
        editSourceOfPaymentLoading: false,
      };
    case CREATE_SOURCE_OF_PAYMENT:
      return {
        ...state,
        sourceOfPaymentList: [payload, ...state.sourceOfPaymentList],
        editSourceOfPaymentLoading: false,
        sourceOfPaymentLoading: false,
      };
    case EDIT_SOURCE_OF_PAYMENT:
      return {
        ...state,
        sourceOfPaymentDetails: payload,
        sourceOfPaymentList: state.sourceOfPaymentList.map((source) =>
          source._id === payload._id
            ? {
                ...source,
                name: payload.name,
              }
            : source
        ),
        editSourceOfPaymentLoading: false,
        sourceOfPaymentLoading: false,
      };
    case DELETE_SOURCE_OF_PAYMENT:
      return {
        ...state,
        sourceOfPaymentList: state.sourceOfPaymentList.filter(
          (log) => log._id !== payload
        ),
        sourceOfPaymentLoading: false,
        editSourceOfPaymentLoading: false,
      };
    default:
      return state;
  }
}
